const BRAND_PREFIX = process.env.NEXT_PUBLIC_BRAND === 'ZVRNL' ? 'zvrnl' : 'vaknl';
const ENV_PREFIX = process.env.NODE_ENV === 'development' ? '_dev' : '';

export function addBrandPrefix(baseName: string): string {
	return `${BRAND_PREFIX}${ENV_PREFIX}_${baseName}`;
}
